import '../auth.scss';

import { ReactComponent as Logo } from '@basqet-dashboard/common/assets/logo.svg';
import { Button, FormInput } from '@basqet-dashboard/common/components';
import { APP_NAME } from '@basqet-dashboard/common/config';
import { useDocumentTitle } from '@basqet-dashboard/common/hooks';
import { authUserSchema, FLAGS } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useHistory, useParams } from 'react-router-dom';

import { RegisterV2 } from './register-v2';
import { Setup } from './setup';

function Signup() {
  const flagEnabled = useFeatureFlagEnabled(FLAGS.ONBOARDING_V2);

  if (flagEnabled === false) {
    return <RegisterV1 />;
  }

  return <RegisterV2 />;
}

function RegisterV1() {
  const [user, setUser] = useState({});

  const { step } = useParams();

  useDocumentTitle('Create an Account');

  return (
    <main className="auth">
      {(step === 'basic' || !step) && <SignupForm user={user} setUser={setUser} />}
      {step === 'setup' && <Setup user={user} />}
    </main>
  );
}

const SignupForm = ({ setUser, user }) => {
  const history = useHistory();

  const {
    register,
    handleSubmit,

    formState: { errors }
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(authUserSchema),
    defaultValues: {
      email: user.email,
      password: user.password
    }
  });
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = async (body) => {
    setIsLoading(true);
    setUser(body);
    history.push('/signup/setup');
  };

  return (
    <div className="auth__content">
      <div className="auth__stage">
        <div className="auth__stage__half" />
      </div>
      <h1 className="page__title">
        Create a {APP_NAME} <span className="text-cursive">account</span>
      </h1>
      <div className="auth__card">
        <Logo />
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="auth__card__input-area">
            <FormInput
              label="Email"
              placeholder="Enter your email"
              name="email"
              type="email"
              error={errors.email && errors.email.message}
              register={register('email')}
            />
            <FormInput
              label="Password"
              placeholder="Enter your password"
              name="password"
              type="password"
              error={errors.password && errors.password.message}
              {...register('password')}
            />
          </div>
          <Button isFull isLoading={isLoading}>
            Create an account
          </Button>
        </form>
        <p className="auth__agreement">
          By signing up, you agree to our{' '}
          <a href="https://basqet.com/terms-of-use" target="_blank" rel="noreferrer">
            Terms
          </a>{' '}
          &{' '}
          <a href="https://basqet.com/privacy-policy" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
        </p>
        <p className="auth__link">
          I already have an account, <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
};

SignupForm.propTypes = {
  // setShowSetup: PropTypes.func,
  setUser: PropTypes.func,
  user: PropTypes.object,
  formErrors: PropTypes.object
};

export { Signup };
